import {Injectable} from '@angular/core';
import * as libPhoneNumber from 'google-libphonenumber';
import PhoneNumber = libPhoneNumber.PhoneNumber;


@Injectable({
    providedIn: 'root'
})
export class PhoneValidationIntlService {

    phoneUtil = libPhoneNumber.PhoneNumberUtil.getInstance();
    phoneNumberFormat = libPhoneNumber.PhoneNumberFormat;

    constructor() {
    }

    public formatPhoneNumber(phoneNumber: any, countryCode: any) {

        try {
            const phoneObj: PhoneNumber = this.getGooglePhoneNumberObj(phoneNumber, countryCode);
            return this.phoneUtil.format(phoneObj, this.phoneNumberFormat.INTERNATIONAL);
        } catch (e) {
            console.log('CountryCode: "' + countryCode + '" ' + e);
        }
        return phoneNumber.toString();
    }

    public isValidNumber(phoneNumber: any, countryCode: any): boolean {
        try {
            const phoneObj: PhoneNumber = this.getGooglePhoneNumberObj(phoneNumber, countryCode);
            return this.phoneUtil.isValidNumber(phoneObj);
        } catch (e) {
            console.log('CountryCode: "' + countryCode + '" ' + e);
        }

        return false;
    }

    public getGooglePhoneNumberObj(phoneNumber: any, countryCode: any): PhoneNumber {
        const phoneObj: PhoneNumber = new PhoneNumber();
        phoneObj.setCountryCode(Number(countryCode));
        phoneObj.setNationalNumber(Number(phoneNumber));
        return phoneObj;
    }

}
